<template>
  <management-page :pageName="pageName" :menu="menu" class="management" />
</template>

<script>
import { managementViewMixin } from "@/mixins/management/managementViewMixin";
import ManagementPage from "@/components/Management/Management";
import DataSVG from "@/assets/management/data.svg";
import AccountsSVG from "@/assets/management/accounts.svg";
import ManagementSVG from "@/assets/management/management.svg";
import IntegrationsSVG from "@/assets/management/integrations.svg";
import { checkPermissionsMixin } from "@/mixins/checkPermissionsMixin";

import { mapActions } from "vuex";

export default {
  name: "SystemManagement",

  components: { ManagementPage },

  mixins: [managementViewMixin, checkPermissionsMixin],

  computed: {
    /**
     * Determine the page title
     * @returns {VueI18n.TranslateResult}
     */
    pageName() {
      return this.$i18n.t("SystemManagement");
    },

    /**
     * Determines the current company type
     * @returns {string}
     */
    currentCompanyType() {
      return localStorage.getItem("company_type");
    },

    /**
     * Determines the menu available in the sidebar on the page
     * @returns {[{submenu: [{route: string, dev: boolean, name: string, disabled: boolean}, {route: string, dev: boolean, name: string, disabled: boolean}, {route: string, dev: boolean, name: string, disabled: boolean}], name: string, icon, disabled: boolean}, {submenu: [{route: string, dev: boolean, name: VueI18n.TranslateResult, disabled: boolean}, {route: string, dev: boolean, name: VueI18n.TranslateResult, disabled: boolean}, {route: string, dev: boolean, name: string, disabled: boolean}], name: VueI18n.TranslateResult, icon, disabled: boolean}, {submenu: [{route: string, dev: boolean, name: string, disabled: boolean}], name: string, icon, disabled: boolean}, {submenu: [{route: string, dev: boolean, name: VueI18n.TranslateResult, disabled: boolean}, {route: string, dev: boolean, name: string, disabled: boolean}], name: VueI18n.TranslateResult, icon, disabled: boolean}]}
     */
    menu() {
      let menu = [
        {
          name: this.$i18n.tc("Account", 2),
          icon: AccountsSVG,
          disabled: false,
          submenu: [
            {
              name: this.$i18n.tc("User", 2),
              route: "users",
              disabled: !this.userHasManagementPermission("user_list"),
              dev: false
            },
            {
              name: this.$i18n.tc("Company", 2),
              route: "companies",
              disabled: !this.userHasManagementPermission("company_list"),
              dev: false
            },
            {
              name: this.$i18n.tc("Role", 2),
              route: "client-roles",
              disabled: !(
                (this.isSuperAdmin || this.isAdmin) &&
                this.userHasManagementPermission("client_role_list")
              ),
              dev: false
            } /*,
            {
              name: this.$i18n.tc("CompaniesUsers"),
              page: UsersInCompanies,
              disabled: !(
                this.userHasManagementPermission("user_list") &&
                this.userHasManagementPermission("company_list") &&
                this.userHasManagementPermission("user_company_list")
              ),
              dev: true
            }*/
          ]
        },
        {
          name: this.$i18n.t("SystemSettings"),
          icon: ManagementSVG,
          disabled: false,
          submenu: [
            {
              name: this.$i18n.t("NetworkRules"),
              route: "network-rules",
              disabled: !this.userHasManagementPermission("network_rule_list"),
              dev: false
            },
            {
              name: this.$i18n.t("ListsSettings"),
              route: "list-settings",
              disabled: !this.userHasFibercloudPermission("list_list"),
              dev: false
            },
            {
              name: this.$i18n.tc("CustomFields", 2),
              route: "custom-fields",
              disabled: !this.userHasManagementPermission(
                "custom_field",
                "list"
              ),
              dev: false
            }
          ]
        },
        {
          name: this.$i18n.tc("Integration", 2),
          icon: IntegrationsSVG,
          disabled: false,
          submenu: [
            {
              name: this.$i18n.tc("Integration", 2),
              route: "integrations",
              disabled: !this.userHasManagementPermission(
                "third_party_apis_service_list"
              ),
              dev: false
            },
            {
              name: "Consumables",
              route: "consumables",
              disabled: !this.userHasManagementPermission(
                "third_party_apis_service_list"
              ),
              dev: false
            }
          ]
        },
        {
          name: this.$i18n.t("License"),
          icon: DataSVG,
          disabled: false,
          submenu: [
            {
              name: this.$i18n.t("Client"),
              route: "license-client",
              disabled: !(
                this.isSuperAdmin ||
                (this.isAdmin &&
                  this.currentCompanyType === "1" &&
                  this.userHasManagementPermission("configuration_list"))
              ),
              dev: false
            },
            {
              name: this.$i18n.tc("Module", 2),
              route: "license-modules",
              disabled: false,
              dev: false
            }
          ]
        }
      ];
      menu[0].disabled = !this.isMenuEnabled(menu[0]);
      menu[1].disabled = !this.isMenuEnabled(menu[1]);
      return menu;
    }
  },

  created() {
    if (this.userHasFibercloudPermission("list_list")) {
      this.GET_ALL_LISTS();
    }
  },

  methods: {
    ...mapActions(["GET_ALL_LISTS"])
  }
};
</script>



// WEBPACK FOOTER //
// src/views/SystemManagement.vue